import React from "react";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Input,
    FormGroup,
	Label,
	Table
} from "reactstrap";
import moment from "moment";

import { createBrokerRequest, getBrokerRequest, updateBrokerRequest } from "../../api/broker";	
import { getBrokerCommissionsRequest, createBrokerCommissionRequest, deleteBrokerCommissionRequest } from "../../api/brokerCommissions";

class BrokerForm extends React.Component {

    constructor(props) {
		super(props);
		this.state = {
			broker: null,
			error: null,
			saving: false,
			showCommissionForm: false,
			commissionForm: {
				year: '',
				isVAT: null,
				holdingTax: 0
			},
			filtersCommissions: {
				year: ''
			},
			brokerCommissions: [],
			savingCommission: false
		}
	}

    async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');

		if (id) {
			try {
				const broker = await getBrokerRequest(id);
				this.setState({ broker });

				// Load broker commissions
				const commissionsResponse = await getBrokerCommissionsRequest({ broker: id });
				this.setState({ 
					brokerCommissions: commissionsResponse.brokerCommissions || []
				});
			} catch(err) {
				this.setState({
					error: err.message || 'There was an error fetching broker'
				});
			}
		} else {
			this.setState({
				broker: {
					name: '',
				}
			})
		}
	}
    goTo = (path) => this.props.history.push(path);

	save = async () => {
		this.setState({
			saving: true
		})

		const { broker } = this.state;
		const { _id } = broker;
		try {
			if (_id) {
				await updateBrokerRequest(broker);
			} else {
				await createBrokerRequest(broker);
			}
			this.setState({
				saving: false
			})
			this.goTo('/brokers');
		} catch (err) {
			console.log(err, "error");
			this.setState({
				error: err.message || 'There was an error saving Broker',
				saving: false
			})
		}
	
	}

    onChangeField = (e) => {
		const { target } = e;
		let { name, value } = target;
		
		if(name === 'commission_percentage') {
			value = Number(value);
		} else if(name === 'isVatable') {
			value = value === 'true';
		}
		
		// Handle nested companyAddress fields
		if(name.includes('companyAddress.')) {
			const field = name.split('.')[1];
			this.setState(prevState => ({
				broker: {
					...prevState.broker,
					companyAddress: {
						...prevState.broker.companyAddress,
						[field]: value
					}
				},
			}));
			return;
		}
		
		this.setState(prevState => ({
			broker: {
				...prevState.broker,
				[name]: value,
			},
		}));
	}

	handleCommissionChange = (e) => {
		const { target } = e;
		const { name, value } = target;
		this.setState(prevState => ({
			commissionForm: {
				...prevState.commissionForm,
				[name]: value
			}
		}));
	}

	toggleCommissionForm = () => {
		this.setState(prevState => ({
			showCommissionForm: !prevState.showCommissionForm,
			commissionForm: {
				year: new Date().getFullYear(),
				isVAT: null,
				holdingTax: 0
			}
		}));
	}

	addCommission = async () => {
		const { commissionForm, broker } = this.state;
		if (!commissionForm.year || commissionForm.isVAT === null || !commissionForm.holdingTax) {
			this.setState({ error: 'Please fill in all required fields' });
			return;
		}

		this.setState({ savingCommission: true });
		try {
			const commissionData = {
				...commissionForm,
				broker: broker._id,
			};

			await createBrokerCommissionRequest(commissionData);
			
			// Refresh commissions list
			const commissionsResponse = await getBrokerCommissionsRequest({ 
				broker: broker._id,
				year: this.state.selectedYear 
			});
			
			this.setState({
				brokerCommissions: commissionsResponse.brokerCommissions || [],
				showCommissionForm: false,
				savingCommission: false,
				commissionForm: {
					year: new Date().getFullYear(),
					isVAT: null,
					holdingTax: 0
				}
			});
		} catch (error) {
			this.setState({ 
				error: error.message || 'Error creating commission',
				savingCommission: false
			});
		}
	}

	deleteCommission = async (id) => {
		try {
			await deleteBrokerCommissionRequest(id);
			const { broker } = this.state;
			const commissionsResponse = await getBrokerCommissionsRequest({ 
				broker: broker._id,
				year: this.state.selectedYear 
			});
			this.setState({ brokerCommissions: commissionsResponse.brokerCommissions || [] });
		} catch (error) {
			this.setState({ error: error.message || 'Error deleting commission' });
		}
	}

	filterCommissionsByYear = async (year) => {
		const { broker } = this.state;
		this.setState({ selectedYear: year });
		const commissionsResponse = await getBrokerCommissionsRequest({ 
			broker: broker._id,
			year 
		});
		this.setState({ brokerCommissions: commissionsResponse.brokerCommissions || [] });
	}

    render() {

		const {
			broker = {},
			error = null,
			saving
		} = this.state;

		const {
			_id,
			name,
			email,
			phone,
			dateOfBirth,
			isVatable,
			companyAddress,
			prcNumber,
			prcDate,
			pcrExpiration
		} = broker || {};

        return (
            <>
                <div className="content">
                <Row>
                    <Col md="12">
                    <Card>
                        <CardHeader>
                            <CardTitle className="d-inline-block" tag="h4">
                                Broker
                            </CardTitle>
                            <Button
								className="float-right"
								color="default"
								onClick={() => this.goTo('/brokers')}
                            >
							Back
                  			</Button>
                        </CardHeader>
                        <CardBody>
							<Row>
								<Col sm={12} md={6}>
									<FormGroup>
										<Label>Name <span className="required-start">*</span></Label>
										<Input
											type="text"
											name="name"
											value={name || ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
								<Col sm={12} md={6}>
									<FormGroup>
										<Label>Email Address <span className="required-start">*</span></Label>
										<Input
											type="text"
											name="email"
											value={email || ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col sm={12} md={6}>
									<FormGroup>
										<Label>Contact Numbers/Mobile</Label>
										<Input
											type="text"
											name="phone"
											value={phone || ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col sm={12} md={6}>
									<FormGroup>
										<Label>Date of Birth</Label>
										<Input
											type="date"
											name="dateOfBirth"
											value={dateOfBirth ? moment(dateOfBirth).format('YYYY-MM-DD') : ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
								<Col sm={12} md={6}>
									<FormGroup>
										<Label>Is Vatable</Label>
										<Input
											type="select"
											name="isVatable"
											value={isVatable || false}
											onChange={this.onChangeField}
										>
											<option value={false}>No</option>
											<option value={true}>Yes</option>
										</Input>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col sm={12}>
									<FormGroup>
										<Label>Company Address</Label>
										<Input
											type="text"
											name="companyAddress.street"
											placeholder="Street"
											value={companyAddress?.street || ''}
											onChange={this.onChangeField}
										/>
										<Input
											type="text"
											name="companyAddress.city"
											placeholder="City"
											className="mt-2"
											value={companyAddress?.city || ''}
											onChange={this.onChangeField}
										/>
										<Input
											type="text"
											name="companyAddress.state"
											placeholder="State"
											className="mt-2"
											value={companyAddress?.state || ''}
											onChange={this.onChangeField}
										/>
										<Input
											type="text"
											name="companyAddress.country"
											placeholder="Country"
											className="mt-2"
											value={companyAddress?.country || ''}
											onChange={this.onChangeField}
										/>
										<Input
											type="text"
											name="companyAddress.zipCode"
											placeholder="Zip Code"
											className="mt-2"
											value={companyAddress?.zipCode || ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col sm={12} md={4}>
									<FormGroup>
										<Label>PRC Number</Label>
										<Input
											type="text"
											name="prcNumber"
											value={prcNumber || ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
								<Col sm={12} md={4}>
									<FormGroup>
										<Label>PRC Date</Label>
										<Input
											type="date"
											name="prcDate"
											value={prcDate ? moment(prcDate).format('YYYY-MM-DD') : ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
								<Col sm={12} md={4}>
									<FormGroup>
										<Label>PRC Expiration</Label>
										<Input
											type="date"
											name="pcrExpiration"
											value={pcrExpiration ? moment(pcrExpiration).format('YYYY-MM-DD') : ''}
											onChange={this.onChangeField}
										/>
									</FormGroup>
								</Col>
							</Row>
							<Row>
							<Card className="detail-card">
								<CardHeader>
									<h3>Commission information <i role="button" onClick={this.toggleCommissionForm} className="tim-icons icon-simple-add ml-2 cursor-pointer pull-right" /></h3>
								</CardHeader>
								<CardBody>
									{this.state.showCommissionForm && (
										<>
											<Row>
												<Col sm={12} md={6}>
													<FormGroup>
														<Label>Year <span className="required-start">*</span></Label>
														<Input
															type="number"
															name="year"
															value={this.state.commissionForm.year}
															onChange={this.handleCommissionChange}
															placeholder="Enter year"
														/>
													</FormGroup>
												</Col>
												<Col sm={12} md={6}>
													<FormGroup>
														<Label>Is VAT <span className="required-start">*</span></Label>
														<Input
															type="select"
															name="isVAT"
															value={this.state.commissionForm.isVAT}
															onChange={this.handleCommissionChange}
														>
															<option value={null}>--SELECT--</option>
															<option value={false}>No</option>
															<option value={true}>Yes</option>
														</Input>
													</FormGroup>
												</Col>
												<Col sm={12} md={6}>
												<FormGroup>
													<Label>Withholding tax <span className="required-start">*</span></Label>
													<Input
														type="number"
														name="holdingTax"
														value={this.state.commissionForm.holdingTax}
														onChange={this.handleCommissionChange}
														placeholder="Enter percentage"
													/>
												</FormGroup>
												</Col>
											</Row>
											<Row className="mt-4">
												<Col sm={12} className="text-right">
													<Button
														color="secondary"
														className="mr-2"
														onClick={this.toggleCommissionForm}
														disabled={this.state.savingCommission}
													>
														Cancel
													</Button>
													<Button
														color="primary"
														onClick={this.addCommission}
														disabled={this.state.savingCommission}
													>
														{this.state.savingCommission ? "Saving..." : "Save Commission"}
													</Button>
												</Col>
											</Row>
										</>
									)}

									<Row className="mt-4">
										<Col sm={12}>
											<FormGroup>
												<Label>Filter by Year</Label>
												<Input
													type="select"
													value={this.state.selectedYear}
													onChange={(e) => this.filterCommissionsByYear(e.target.value)}
													className={this.state.selectedYear ? "" : ' select__placeholder'}
												>
													<option value="">All Years</option>
													{Array.from(new Set(this.state.brokerCommissions.map(c => c.year))).sort((a, b) => b - a).map(year => (
														<option key={year} value={year}>{year}</option>
													))}
												</Input>
											</FormGroup>
										</Col>
									</Row>

									<Row className="mt-4">
										<Col sm={12}>
											<div className="table-responsive">
												{this.state.brokerCommissions.length > 0 ? (
													<Table>
														<thead>
															<tr>
																<th>Year</th>
																<th>Is VAT</th>
																<th>Withholding Tax</th>
																<th>Actions</th>
															</tr>
														</thead>
														<tbody>
															{this.state.brokerCommissions
																.sort((a, b) => b.year - a.year)
																.map((commission, index) => (
																	<tr key={index}>
																		<td>{commission.year}</td>
																		<td>{commission.isVAT ? 'Yes' : 'No'}</td>
																		<td>{commission.holdingTax}%</td>
																		<td>
																			<i 
																				onClick={() => this.deleteCommission(commission._id)}
																				className="tim-icons icon-trash-simple cursor-pointer"
																			/>
																		</td>
																	</tr>
																))}
														</tbody>
													</Table>
												) : (
													<div className="text-center py-4">
														<p className="text-muted">No commission entries found.</p>
													</div>
												)}
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
							</Row>

							{error ? <div className="alert alert-danger mt-3">
									<span>{error}</span>
								</div> : null
							}
                            <Button color="primary" block={false} className="mb-4" onClick={this.save}>
								{saving
									? "Saving..."
									: _id
										? "Save Changes"
										: "Save Broker"
								}
                            </Button>
                        </CardBody>
                    </Card>
                    </Col>
                </Row>
                </div>
            </>
        )
    	
	}
}

export default BrokerForm;